import { jsxs, Fragment, jsx } from "react/jsx-runtime";
const TravelRoute = ({ isHovered }) => {
  const normal = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "m17.354 9.75-4.149-4.668-.971.864L15.037 9.1H7.085v1.3h7.952l-2.803 3.154.971.863 4.15-4.667Zm2.826.65h12.095c3.8 0 6.825 2.927 6.825 6.475 0 3.547-3.026 6.475-6.825 6.475H14.062c-4.381 0-7.962 3.465-7.962 7.775 0 4.31 3.58 7.775 7.963 7.775H26.74a.65.65 0 1 0 0-1.3H14.063c-3.696 0-6.663-2.915-6.663-6.475 0-3.56 2.967-6.475 6.662-6.475h18.213c4.458 0 8.125-3.452 8.125-7.775 0-4.324-3.667-7.775-8.125-7.775H20.18v1.3Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M30.356 33.483a5.614 5.614 0 0 1 11.227 0c0 .923-.363 1.951-.842 2.924-.487.988-1.128 1.99-1.76 2.879a37.639 37.639 0 0 1-2.47 3.105l-.044.048-.012.013-.004.004-.481-.437-.48.438-.002-.002-.003-.003-.012-.013-.044-.048a36.013 36.013 0 0 1-.735-.855 37.639 37.639 0 0 1-1.736-2.25c-.631-.89-1.273-1.891-1.76-2.88-.478-.972-.842-2-.842-2.923Zm5.614 8.536-.48.438.48.527.48-.528-.48-.437Zm0-.987a37.106 37.106 0 0 0 1.951-2.499c.61-.859 1.21-1.798 1.654-2.7.451-.918.708-1.729.708-2.35a4.314 4.314 0 0 0-8.627 0c0 .621.257 1.432.71 2.35.443.902 1.042 1.841 1.652 2.7a36.304 36.304 0 0 0 1.952 2.498Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M35.97 31.72a1.6 1.6 0 1 0 0 3.203 1.6 1.6 0 0 0 0-3.202Zm-2.901 1.602a2.901 2.901 0 1 1 5.802 0 2.901 2.901 0 0 1-5.802 0Z",
        clipRule: "evenodd"
      }
    )
  ] });
  const normalHover = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M25.5 10.4h6.775c3.8 0 6.825 2.927 6.825 6.475 0 3.547-3.026 6.475-6.825 6.475H14.062c-4.381 0-7.962 3.465-7.962 7.775 0 4.31 3.58 7.775 7.963 7.775H27.39v-1.3H14.062c-3.695 0-6.662-2.915-6.662-6.475 0-3.56 2.967-6.475 6.662-6.475h18.213c4.458 0 8.125-3.452 8.125-7.775 0-4.324-3.667-7.775-8.125-7.775H25.5v1.3Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M30.356 33.483a5.614 5.614 0 0 1 11.227 0c0 .923-.363 1.951-.842 2.924-.487.988-1.128 1.99-1.76 2.879a37.639 37.639 0 0 1-2.47 3.105l-.044.048-.012.013-.004.004-.481-.437-.48.438-.002-.002-.003-.003-.012-.013-.044-.048a36.013 36.013 0 0 1-.735-.855 37.639 37.639 0 0 1-1.736-2.25c-.631-.89-1.273-1.891-1.76-2.88-.478-.972-.842-2-.842-2.923Zm5.614 8.536-.48.438.48.527.48-.528-.48-.437Zm0-.987a37.106 37.106 0 0 0 1.951-2.499c.61-.859 1.21-1.798 1.654-2.7.451-.918.708-1.729.708-2.35a4.314 4.314 0 0 0-8.627 0c0 .621.257 1.432.71 2.35.443.902 1.042 1.841 1.652 2.7a36.304 36.304 0 0 0 1.952 2.498Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M35.97 31.72a1.6 1.6 0 1 0 0 3.203 1.6 1.6 0 0 0 0-3.202Zm-2.901 1.602a2.901 2.901 0 1 1 5.802 0 2.901 2.901 0 0 1-5.802 0ZM22.37 9.75l-4.15-4.668-.971.864L20.052 9.1H12.1v1.3h7.953l-2.804 3.154.972.863L22.37 9.75Z",
        clipRule: "evenodd"
      }
    )
  ] });
  return isHovered ? normalHover : normal;
};
export {
  TravelRoute as default
};
//# sourceMappingURL=TravelRoute.js.map
